import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useCustomHook } from "../../../../GlobalFunctions/globalFunctions";
import DropdownIcon from "../../../components/DropdownIcon/DropdownIcon";

const CancelReason = ({ formik, modalData, updateModalState }) => {
  const { cancelReasonList: dataList } = useCustomHook();
  const inputValue =
    dataList.find((item) => item.key === modalData.cancelReason)?.name || "";
  const [openDropdown, setOpenDropdown] = useState(false);
  const addData = (item) => {
    updateModalState("cancelReason", item);
    setOpenDropdown(false);
  };

  useEffect(() => {
    if (modalData?.status !== "cancelled") {
      updateModalState("cancelReason", "");
    }
  }, [modalData?.status]);
  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "12px",
                  marginRight: "32px",
                },
                marginTop: "24px",
                // marginBottom: "24px",
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="İmtina səbəbi"
              autoComplete="off"
              disabled
              value={inputValue}
              onBlur={() => formik.setFieldTouched("cancelReason", true)}
            />
            <DropdownIcon
              setOpenDropdown={setOpenDropdown}
              openDropdown={openDropdown}
            />
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
          >
            {dataList.map((item) => (
              <li key={item.key} onClick={() => addData(item.key)}>
                <h4>{item.name}</h4>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {formik.errors.cancelReason && formik.touched.cancelReason && (
        <small className="validation-err-message">
          {formik.errors.cancelReason}
        </small>
      )}
    </>
  );
};

export default CancelReason;
